export const widgetDefaultSize = 130;
export const widgetSetupContentChartHeight = 560;
